
import React from 'react';

let LimelightVideo = React.createClass({

    /**
     * Need to inject the limelight embed code as raw HTML for it to work properly
     * The embed.js is required. You can require('./path/to/embed.js') for your vendor.js or put the following script
     * into the HTML below.
     *
     * <script id="limelightembedjs" src="//video.limelight.com/player/embed.js"></script>
     */
    injectScript(options) {
       var width, height, screenRelWidth, screenRelHeight, margin = options.margin;

       screenRelWidth = window.screen.availWidth-margin;
       screenRelHeight = (window.screen.availWidth-margin)*2/3;

       width = parseInt( options.width.toString().replace('px', '') );
       height = parseInt( options.height.toString().replace('px', '') );

       width = ((screenRelWidth <= width) ? screenRelWidth : width) + 'px';
       height = ((screenRelHeight <= height) ? screenRelHeight : height) + 'px';

       return {
           __html: `<span class="LimelightEmbeddedPlayer">
           <div id="${options.id}"></div>
          
           </span>`
       };
    },

    componentWillMount() {
       const scriptTag = document.getElementById('limelightembedjs');
       this.limelightembedjsLoaded = false;

       if(!scriptTag){
         window.limelightPlayerCallback = function(playerId, eventName, data) {
           console.info('window.limelightPlayerCallback', playerId, eventName, data);
           if (eventName === 'onPlayerLoad' && (window.LimelightPlayer.getPlayers() === null || window.LimelightPlayer.getPlayers().length === 0)) {
             window.LimelightPlayer.registerPlayer(playerId);
           }
         }

         const script = document.createElement('script');
         script.src = '//video.limelight.com/player/limelightjs-player.js';
         script.async = true;
         script.onload = this.onEmbedScriptLoad;
         document.body.appendChild(script);

       }else{
         this.limelightembedjsLoaded = true;
       }
    },

    onEmbedScriptLoad(){
      this.limelightembedjsLoaded = true;
      this.initEmbed(this.props.id.toString());
    },

    initEmbed(id){
      if(this.limelightembedjsLoaded){
        LimelightPlayerUtil.embed({"width":this.props.width, "playerForm":"Player","mediaId":this.props.source,"height":this.props.height,"playerId":id});
      }
    },

    shouldComponentUpdate(nextProps) {
        let shouldUpdate = true;

        /**
         * Do not update the video player after it has been rendered once
         * This prevents issues with the HTML5 player on mobile devices
         */
        if (nextProps.id === this.props.id) {
            shouldUpdate = false;
        }

        return shouldUpdate;
    },

    componentDidMount() {
        this.initEmbed(this.props.id);
    },

    componentDidUpdate() {
        this.initEmbed(this.props.id);
    },

    render() {
      return (
          <div className="video-wrapper" dangerouslySetInnerHTML={this.injectScript(this.props)} />
      )
    }
});

LimelightVideo.propTypes = {
  id: React.PropTypes.string.isRequired,
  width: React.PropTypes.oneOfType([
    React.PropTypes.number,
    React.PropTypes.string
  ]).isRequired,
  height: React.PropTypes.oneOfType([
    React.PropTypes.number,
    React.PropTypes.string
  ]).isRequired,
  source: React.PropTypes.string.isRequired,
  margin: React.PropTypes.number
};

LimelightVideo.defaultProps = {
  margin: 12
};

module.exports = LimelightVideo;



// WEBPACK FOOTER //
// ./src/components/limelight.js